import React from 'react';
import ContentLayout from '../../../../components/ContentLayout';
import props from '../../../../lib/contentLayoutProps/learning-at-kingston/primary-school/layoutProps';

import image from './bilingual@large.jpg';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="zh" pageKey="our-bilingual-approach">
    <h1>雙語教學方針</h1>
    <p>雙語教學是本校的獨特之處。京斯敦使用普通話及英語授課，期望學生能使用兩種語言學習及參與教學活動。</p>
    <p>
      每班有兩位合資格的班主任，母語分別為英語及普通話。學生每天會有一部分時間使用英語上課，一部分時間使用普通話上課，餘下時間為雙語課。
    </p>
    <p>
      京斯敦的雙語教學從親子班開始，直至六年級畢業。我們提供最理想的學習環境，使學生的雙語如母語般流利。我們為學生的雙語能力引以為傲。在國際文憑小學課程的框架下，小班教學及極佳的師生比例為雙語教學奠定重要的根基。
    </p>
    <img src={image} alt="Our bilingual approach" />
  </ContentLayout>
);
